import { render } from "./App.vue?vue&type=template&id=262f5b75"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&lang=scss"
script.render = render

export default script